import React, { createContext, useContext, useEffect, useState } from "react" 
import { Outlet, useParams, useNavigate } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { CollectionLoader, UnitTitleBlock } from "lib/components"
import { Client } from "." 

const ClientContext = createContext({})
export const useClientCtx = () => useContext(ClientContext)

const defaultClient = {
  name: "",
  subdomain: "",
  description: "",
  customizations: [],
  configs: {
    processing: "html+css"
  },
  templates: [],
  plugins: [],
  activity_log: [],
  tags: []
}

export default function ClientProvider({ className="" }:{ className?:string }){

  const navigate = useNavigate()
  const { cid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const [ lookupId, setLookupId ] = useState<string|null>(null)
  
  const { data:_Clients } = queryTools.resource.parseQueryForApi("client.findAll", {})
  const { data:_Client } = queryTools.resource.parseQueryForApi("client.findById", { _id: cid })
  const saveMethod = queryTools.resource.save(["client.all"])
  
  const saveFn = queryTools.resource.save(["client.all"])
  
  const saveClient = (data:any) => {
    saveFn.mutate({ resource: "client", data } )
  }

  const createNewClient = (e:any) => {
    e.preventDefault()
    const form = document.querySelector("#new-client-name") as HTMLFormElement
    const formData = new FormData(form)
    const newClient = {...defaultClient, name: formData.get("name")}
    saveClient(newClient)
  }

  useEffect(() => {
    if( cid && cid !== "0" ){
      setLookupId(cid) 
    }
  },[cid])

  return (
    <ClientContext.Provider value={{ }}>
      <div className={cn("w-full pt-6", className)}>
        <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="client manager">
          <form id="new-client-name" className="w-full h-8 flex justify-end items-center gap-3">
            <input 
              type="text" 
              name="name" 
              placeholder="New Client Name" 
              className="w-6/12 h-8 bg-transparent border border-solid border-slate-700 px-2" 
            />
            <button className="w-3/12 h-8 bg-teal-800 text-sm uppercase flex justify-center items-center px-2" onClick={createNewClient}>
              Add New
            </button>
          </form>
        </UnitTitleBlock>

        <div className="w-full flex items-stretch gap-4">
          
          <div className="w-2/12 flex border border-solid border-slate-700 overflow-auto scrollbar">
            <CollectionLoader 
              collection={_Clients}
              selectFn={(item:any) => navigate(`/client/${item._id}?action=setup`)}
              selectProp="_id"
              labelProp="name"
              className="w-full"
            />
          </div>

          <div className="w-10/12">
            { _Client !== undefined && ( <Client /> )}
          </div>

        </div>
    
      </div>
    </ClientContext.Provider>
  )
}